
let log = null as any;

// #ifdef MP-WEIXIN
if (typeof wx !== 'undefined' && wx.getRealtimeLogManager) log = wx.getRealtimeLogManager()
// #endif

export default {
  debug(...args: any[]) {
    if (!log) return
    log.debug(...args)
  },
  info(...args: any[]) {
    if (!log) return
    log.info(...args)
  },
  warn(...args: any[]) {
    if (!log) return
    log.warn(...args)
  },
  error(...args: any[]) {
    if (!log) return
    log.error(...args)
  },
  setFilterMsg(msg: string) { // 从基础库2.7.3开始支持
    if (!log || !log.setFilterMsg) return
    if (typeof msg !== 'string') return
    log.setFilterMsg(msg)
  },
  addFilterMsg(msg: string) { // 从基础库2.8.1开始支持
    if (!log || !log.addFilterMsg) return
    if (typeof msg !== 'string') return
    log.addFilterMsg(msg)
  }
}